class OpenTicketPaymentProcessTypeValues {
  static PAY
  static FREE
  static DONATION

  static getList () {
    return [
      { label: 'Pago', value: OpenTicketPaymentProcessTypeValues.PAY },
      { label: 'Gratis', value: OpenTicketPaymentProcessTypeValues.FREE },
      { label: 'Donación', value: OpenTicketPaymentProcessTypeValues.DONATION }
    ]
  }
}

OpenTicketPaymentProcessTypeValues.PAY = 'pay'
OpenTicketPaymentProcessTypeValues.FREE = 'free'
OpenTicketPaymentProcessTypeValues.DONATION = 'donation'

export default OpenTicketPaymentProcessTypeValues
